const getDayArray = (year: number, month: number) => {
  const dayCount = new Date(year, month, 0).getDate();
  return Array.from({ length: dayCount }, (_, i) =>
    String(i + 1).padStart(2, '0')
  );
};

export default getDayArray;
